import {Link, useLocation} from "react-router-dom";
import {theme} from "../../theme";
import {
    isUserLogged,
    useIsAdmin,
} from '../../utils/utilFunctions';
import {useTranslation} from "react-i18next";
import { StudyCycleEnum } from "../../Api";
import { Dropdown } from "antd";
import type { MenuProps } from "antd";
import { useMemo } from "react";

const HeadersLinks = () => {
    const {t} = useTranslation();
    const isAdmin = useIsAdmin();
    const location = useLocation();
    const isDesktop = window.innerWidth > 1215;

    const getLinkStyle = (isActive: boolean) => ({
        fontWeight: isActive ? 600 : "normal",
        color: isDesktop
            ? (isActive ? theme.primaryColor : "black")
            : theme.secondColor,
        fontSize: isDesktop ? "125%" : "20px",
        fontFamily: theme.font,
        padding: isDesktop ? "0" : "5px",
    });

    const isAdminRouteActive = ["/domenii", "/competente", "/laboratoare", "/arii-eafsg"].some(
        (path) => location.pathname === path || location.pathname.startsWith(`${path}/`)
    );

    const adminMenuLinks = [
        { key: "domenii", path: "/domenii", text: "Domenii fundamentale" },
        { key: "competente", path: "/competente", text: "Competențe" },
        { key: "laboratoare", path: "/laboratoare", text: "Săli" },
        { key: "arii-eafsg", path: "/arii-eafsg", text: "Arii EAFSG" },
    ];

    const adminMenuItems: MenuProps["items"] = useMemo(() => adminMenuLinks.map(({ key, path, text }) => {
        const isActive = location.pathname === path || location.pathname.startsWith(`${path}/`);
        return {
            key,
            label: (
                <Link
                    to={path}
                    style={{
                        color: isActive ? theme.primaryColor : "black",
                        fontWeight: isActive ? 600 : "normal",
                    }}
                >
                    {text}
                </Link>
            ),
        };
    }), [location.pathname]);

    return (
        <>
            {isUserLogged() ?
                (<Link
                        to={'/disciplinele-mele'}
                        style={getLinkStyle(location.pathname === '/disciplinele-mele')}
                    >
                        Disciplinele mele
                </Link>)
            : null}

            {isUserLogged() ?
                (<Link
                        to={'/' + StudyCycleEnum.Bachelor + "/programe"}
                        style={getLinkStyle(location.pathname === '/' + StudyCycleEnum.Bachelor + "/programe")}
                    >
                        Programe Licență
                </Link>)
            : null}

            {isUserLogged() ?
                (<Link
                        to={'/' + StudyCycleEnum.Master + "/programe"}
                        style={getLinkStyle(location.pathname === '/' + StudyCycleEnum.Master + "/programe")}
                    >
                        Programe Masterat
                </Link>)
            : null} 

            {isUserLogged() ?
                (<Link
                        to={'/' + StudyCycleEnum.Doctorate + "/programe"}
                        style={getLinkStyle(location.pathname === '/' + StudyCycleEnum.Doctorate + "/programe")}
                    >
                        Programe Doctorat
                </Link>)
            : null}

            {isUserLogged() && isAdmin ?
                (<Dropdown menu={{ items: adminMenuItems }} placement="bottom" trigger={["click"]}>
                    <span
                        style={{
                            ...getLinkStyle(isAdminRouteActive),
                            cursor: "pointer",
                        }}
                    >
                        {t('header.administration')}
                    </span>
                </Dropdown>)
            : null}
                    
        </>
    );

};

export default HeadersLinks;